<template>

    <div class="" :class="{hidden: !loading}">
        <loading></loading>
    </div>

    <form action="" :class="{hidden: loading}" class="form form--floating-label" @submit.prevent="formSubmit" ref='form' >
        <div class="style-emph mb-4">
            Fill out the form below & we’ll be in touch!
        </div>

        <div class="input-container input-container--floating relative h-12 mb-5 " :class="{empty: !formData.contact, error: submittedOnce && errors.contact}">
            <input
                    id="contact-name"
                    type="text"
                    v-model="formData.contact"
                    class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue "
            />
            <label for="contact-name" class="absolute left-2 transition-all px-1 text-blue-gray">
                Contact Name
            </label>
        </div>

        <div class="input-container input-container--floating relative h-12 mb-5 " :class="{empty: !formData.phone , error: submittedOnce && errors.phone}">
            <input
                    id="phone"
                    type="text"
                    v-model="formData.phone"
                    class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
            />
            <label for="phone" class="absolute left-2 transition-all px-1 text-blue-gray">
                Phone
            </label>
        </div>

        <div class="input-container input-container--floating relative h-12 mb-5 " :class="{empty: !formData.email, error: submittedOnce && errors.email}">
            <input
                    id="email"
                    type="email"
                    v-model="formData.email"
                    class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
            />
            <label for="email" class="absolute left-2 transition-all px-1 text-blue-gray">
                Email Address
            </label>
        </div>


        <div class="input-container input-container--floating relative h-12 mb-5 " :class="{empty: !formData.order_number , error: submittedOnce && errors.order_number}">
            <input
                    id="order_number"
                    type="text"
                    v-model="formData.order_number"
                    class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
            />
            <label for="phone" class="absolute left-2 transition-all px-1 text-blue-gray">
                Order Number
            </label>
        </div>

<!--
        <div class="input-container input-container&#45;&#45;check mb-5 ">
            <label class="flex justify-start items-start cursor-pointer">
                <div class="bg-white border rounded border-blue-gray w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2">
                    <input type="checkbox" class="opacity-0 absolute" v-model="osa">
                    <svg class="fill-current hidden w-4 h-4 text-red pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
                </div>
                <div class="select-none text-blue-dark">OSA Service Call</div>
            </label>
        </div>-->

        <div class="input-container input-container--floating relative mb-5 " :class="{empty: !formData.comment, error: submittedOnce && errors.comment}">
            <textarea
                    id="comment"
                    v-model="formData.comment"
                    class="h-full w-full px-2 pt-3 transition-all border-blue-gray rounded text-blue">
            </textarea>

            <label for="comment" class="absolute left-2 transition-all bg-white px-1 text-blue-gray">
                Please tell us how we can assist...
            </label>
        </div>

        <div v-if="submittedOnce && errors.message" class="bg-red text-white mt-10 mb-5 px-3 py-2 rounded ">
            {{ errors.message }}
        </div>

        <div class="mt-10 flex flex-col md:flex-row items-center ">
            <button type="submit" class="btn w-full md:w-auto">Book the Service Call</button>
            <a
                    @click="goBack"
                    class="mt-3 md:mt-0 md:ml-8 text-red hover:text-red-hover font-light underline cursor-pointer">Cancel Form</a>
        </div>
    </form>
</template>

<script charset="utf-8">

import { values, join, get } from 'lodash';
import Loading from '../includes/Loading.vue';
import Vuex from 'vuex';

export default {
    name: 'ServiceCallForm',
    props: ['equipmentID'],
    data() {
        return {
            formData: {
                contact: '',
                phone: '',
                email: '',
                fault: 'Customer Portal',
                order_number : '',
                osa: false,
                comment: ''
            },

            equipment: {
                order_number_required: false
            },
            loading: false,
            submittedOnce: false,

            'errors': {
                contact: 'This field is required',
                phone: 'Phone need to have at least 7 numbers',
                email: 'This field is required',
                //fault: 'This field is required',
                comment: 'This field is required',
                order_number : '',
            }
        }
    },

    components: {
        Loading
    },

    emits: ["submit-success"],

    watch: {
        formData: {
            handler(newVal){
                this.errors.message = '';
                this.errors.contact = newVal.contact ? '' : 'This field is required';
                this.errors.phone   = ! newVal.phone || newVal.phone.length >= 7 ? '' : 'Phone need to have at least 7 numbers';
                this.errors.email   = newVal.email  ? '' : 'This field is required';
                //this.errors.fault   = newVal.fault  ? '' : 'This field is required';
                this.errors.comment   = newVal.comment  ? '' : 'This field is required';
                this.errors.order_number  = !newVal.order_number && this.currentItem.order_number_required  ? 'This field is required' : '';

                if(newVal.comment.length > 500){
                    newVal.comment = newVal.comment.substring(0,500);
                }
            },
            deep: true
        }
    },

    computed: {
        ...Vuex.mapGetters('equipments', {
            currentItem: 'currentItem'
        }),
        ...Vuex.mapGetters('profile', {
            profile: 'profile'
        }),
    },

    created() {
        if(this.profile.isAuth() && !this.profile.isSharpAdmin()){
            this.formData.contact  = this.profile.first_name +  ' ' + (this.profile.last_name ? this.profile.last_name : '');
            this.formData.phone  = this.profile.phone ? this.profile.phone : '';
            this.formData.email  = this.profile.email;
        }
    },


    methods: {
        ...Vuex.mapActions('equipments', {
            createJobentry: 'createJobentry'
        }),

        formSubmit() {
            this.submittedOnce = true;
            this.errors.message = '';

            // do not submit if form has errors
            if (join(values(this.errors), '')) {
                return;
            }

            let data = {
                war_id: this.equipmentID,
                contact: this.formData.contact,
                phone: this.formData.phone,
                email: this.formData.email,
                fault: this.formData.fault,
                comment: this.formData.comment,
                cust_order_num : this.formData.order_number,
            }
            this.loading = true;
            this.createJobentry(data)
            .then(res => {
                this.loading = false;
                this.$emit('submit-success', res.job_number);
            })
            .catch(err => {
                this.loading = false;
                this.errors = {
                    message: 'The given data was invalid'
                }
            })
        },

        goBack(){
            if(!this.profile.isAuth()){
                this.$router.push({
                    name: 'autologin', query: { war_id: this.currentItem ? this.currentItem.id : '', serial: this.currentItem ? this.currentItem.serial : '' }
                });
            } else if(this.profile.isUser() || this.profile.isManager()){
                this.$router.push({
                    name: 'dashboard'
                });
            } else{
                this.$router.go(-1);
            }

        }
    }
}
</script>
